import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './WhyBlock.css';
//import { FormattedMessage } from 'react-intl';

// Locale
//import messages from '../../../locale/messages';

class WhyBlock extends Component {
  render() {
    return (
  
          <Grid className={s.whybnb}>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
              <Col xs={12} sm={6} md={6} lg={6} className={s.whyblock}>
                <h4 className={s.common}>With pleXpad it's easy</h4>
                <p className={s.common}>Booking your space within a few clicks means saving hours of tedious enquiry forms, phone calls and appointments, freeing you to focus on what's most important in your business.</p>
              </Col>

              <Col xs={12} sm={6} md={6} lg={6} className={s.whyblock}>
                <h4 className={s.common}>Who should use pleXpad?</h4>
                <p className={s.common}>Whether you are a start-up looking to book your first office or an established multi-national looking for additional space, pleXpad is right for you. Book from a single day to several months and beyond.</p>
              </Col>
              </Col>
            </Row>
          </Grid>
    );
  }
}

export default withStyles(s)(WhyBlock);



// WEBPACK FOOTER //
// src/components/FindOutMore/WhyBlock/WhyBlock.js